import captionToneRules from '../../../shared/caption-tone-rules.json';
const rules = captionToneRules;
export const CAPTION_TONE_DICTIONARY_VERSION = rules.version;
export const CAPTION_TONE_DICTIONARY = rules.dictionary;
export const CAPTION_TONE_TEXT_RULES = rules.textRules;
export const CAPTION_TONE_THRESHOLDS = rules.thresholds;
export const CAPTION_TONE_ACCESSIBILITY_LABELS = rules.toneAccessibilityLabels;
export const CAPTION_TONE_SURFACE_POLICIES = rules.surfacePolicies;
export function normalizeExpressionLabel(value) {
    return value.toLowerCase().replace(/[^a-z]+/g, ' ').trim();
}
export function findCaptionToneDictionaryEntry(label) {
    const normalizedLabel = normalizeExpressionLabel(label);
    return CAPTION_TONE_DICTIONARY.find(entry => entry.labels.includes(normalizedLabel));
}
export function getUnmappedHumeExpressions(expressions) {
    if (!Array.isArray(expressions)) {
        return [];
    }
    return expressions
        .filter(expression => expression
        && typeof expression.name === 'string'
        && typeof expression.score === 'number'
        && !findCaptionToneDictionaryEntry(expression.name))
        .map(expression => ({
        label: normalizeExpressionLabel(expression.name),
        score: Math.min(Math.max(expression.score, 0), 1)
    }));
}
